// extracted by mini-css-extract-plugin
export default {"self":"UserList_self__OGoed","pagination":"UserList_pagination__0tPYi"};